import React from 'react';
import { colors, spacing, typography } from '../../../design-system/index.js';

export const ResumeTimeline = () => {
  const sectionStyles = {
    padding: `${spacing[16]} 0`,
    borderBottom: `1px solid ${colors.border.light}`,
  };

  const titleStyles = {
    fontSize: typography.fontSize['2xl'],
    fontWeight: typography.fontWeight.light,
    color: colors.text.primary,
    textAlign: 'center',
    marginBottom: spacing[12],
    margin: `0 0 ${spacing[12]} 0`,
  };

  const timelineStyles = {
    position: 'relative',
    maxWidth: '800px',
    margin: '0 auto',
    padding: 0,
    listStyle: 'none',
  };

  const timelineLineStyles = {
    position: 'absolute',
    left: '30px',
    top: 0,
    bottom: 0,
    width: '2px',
    backgroundColor: colors.border.default,
    zIndex: 1,
  };

  const timelineItemStyles = {
    position: 'relative',
    marginBottom: spacing[8],
    paddingLeft: spacing[16],
    opacity: 0,
    animation: 'slideInFromLeft 0.6s ease forwards',
  };

  const timelineDotStyles = {
    position: 'absolute',
    left: '22px',
    top: '8px',
    width: '16px',
    height: '16px',
    backgroundColor: colors.text.primary,
    borderRadius: '50%',
    border: `3px solid ${colors.background.primary}`,
    zIndex: 2,
  };

  const timelineContentStyles = {
    backgroundColor: colors.background.secondary,
    padding: spacing[6],
    borderRadius: spacing.borderRadius.base,
    border: `1px solid ${colors.border.default}`,
    transition: 'all 0.3s ease',
  };

  const timelineHeaderStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: spacing[3],
    flexWrap: 'wrap',
    gap: spacing[2],
  };

  const positionStyles = {
    fontSize: typography.fontSize.lg,
    fontWeight: typography.fontWeight.normal,
    color: colors.text.primary,
    margin: 0,
  };

  const companyStyles = {
    fontSize: typography.fontSize.base,
    fontWeight: typography.fontWeight.light,
    color: colors.text.secondary,
    margin: 0,
  };

  const periodStyles = {
    fontSize: typography.fontSize.sm,
    color: colors.text.muted,
    backgroundColor: colors.background.tertiary,
    padding: `${spacing[1]} ${spacing[3]}`,
    borderRadius: spacing.borderRadius.full,
    whiteSpace: 'nowrap',
  };

  const descriptionStyles = {
    fontSize: typography.fontSize.base,
    lineHeight: typography.lineHeight.loose,
    color: colors.text.secondary,
    margin: 0,
  };

  const timelineData = [
    {
      position: "高级前端工程师",
      company: "科技公司 A",
      period: "2022 - 至今",
      description: "负责企业级应用的前端架构设计，主导设计系统构建，提升团队开发效率 40%。技术栈包括 React、TypeScript、Figma API 等。"
    },
    {
      position: "全栈开发工程师", 
      company: "创业公司 B",
      period: "2020 - 2022",
      description: "从零搭建产品技术架构，负责前后端开发。成功上线 3 个核心产品模块，用户量增长 300%。"
    },
    {
      position: "前端开发工程师",
      company: "互联网公司 C", 
      period: "2018 - 2020",
      description: "参与大型电商平台开发，负责用户端和管理端的功能实现。优化页面性能，首屏加载时间减少 50%。"
    },
    {
      position: "计算机科学学士",
      company: "某知名大学",
      period: "2014 - 2018", 
      description: "专业排名前 10%，获得多项编程竞赛奖项。主修算法与数据结构、软件工程、人机交互等课程。"
    }
  ];

  const handleMouseEnter = (e) => {
    e.currentTarget.style.transform = 'translateX(5px)';
    e.currentTarget.style.boxShadow = spacing.shadow.lg;
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.transform = 'translateX(0)';
    e.currentTarget.style.boxShadow = 'none';
  };

  return (
    <section style={sectionStyles} className="resume-timeline">
      <h2 style={titleStyles}>个人履历</h2>
      
      <ul style={timelineStyles} className="timeline">
        <div style={timelineLineStyles} />
        
        {timelineData.map((item, index) => (
          <li 
            key={index} 
            style={{
              ...timelineItemStyles,
              animationDelay: `${index * 0.2}s`
            }} 
            className="timeline-item"
          >
            <div style={timelineDotStyles} />
            <div 
              style={timelineContentStyles}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <div style={timelineHeaderStyles}>
                <div>
                  <h3 style={positionStyles}>{item.position}</h3>
                  <p style={companyStyles}>{item.company}</p>
                </div>
                <span style={periodStyles}>{item.period}</span>
              </div>
              <p style={descriptionStyles}>{item.description}</p>
            </div>
          </li>
        ))}
      </ul>

      <style>{`
        @keyframes slideInFromLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
      `}</style>
    </section>
  );
};
